var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w1200 auto confirm-order-panel"},[_c('div',{staticClass:"confirm-order-title"},[_vm._v(_vm._s(_vm.titleName))]),_vm._v(" "),_c('div',{staticClass:"confirm-order-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/confirm-order-panel.vue